import React from 'react';
import MainLayoutMobile from 'layouts/main-layout/main-layout.mobile';
import Container from 'atomic/container';
import Box from 'atomic/box';

type StaticPageLayoutMobileProps = {
    children: React.ReactNode;
};

const StaticPageLayoutMobile: React.FC<StaticPageLayoutMobileProps> = ({ children }) => (
    <MainLayoutMobile
        disableAdSlots={true}
    >
        <Container className="static-page">
            <Box className="static-page__content">
                {children}
            </Box>
        </Container>
    </MainLayoutMobile>
);

export default StaticPageLayoutMobile;
